<template>
    <div
        class="error-tab">
        <div
            v-if="Object.entries(computedErrors).length"
            class="error-tab_content">
            <h5 v-if="computedErrors.hasOwnProperty('errorTitle')">
                {{ computedErrors.errorTitle }}
            </h5>
            <p v-if="computedErrors.hasOwnProperty('errorMessage')">
                {{ computedErrors.errorMessage }}
            </p>
        </div>
        <div
            v-else
            class="error-tab_content">
            <h5>{{ $t('Error loading') }}</h5>
            <p>{{ $t('We were unable to load the menu, refresh the page or scan the QR code again') }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "ErrorScreen",
    computed: {
        computedErrors: function () {
            return this.$route.params
        }
    }
}
</script>

<style lang="scss" scoped>
@import "src/scss/assets/variables";

.error-tab {
    box-sizing: border-box;
    background-color: $color_matterhorn;
    height: 100%;
    background-image: url("/img/background/line-bg.png");
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;

    &_content {
        color: $color_white;
        text-align: center;

        h5 {
            font-size: 24px;
            font-weight: 700;
            color: $color_white;
        }

        p{
            font: {
                size: 18px;
            }
        }
    }
}

</style>
